export default function PMono(props) {
  if (props.label === undefined) {
    return <p style={{fontFamily: 'monospace'}} className="mb-0"><b>{props.value}</b></p>
  }
  return <p style={{fontFamily: 'monospace'}} className="mb-0">{props.label}: <b>{props.value}</b></p>
}

